import { LogLevel, PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from '../../../environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: 'https://rhapsody.onelogin.com/oidc/2',
    redirectUrl: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    forbiddenRoute: '',
    unauthorizedRoute: '',
    clientId: environment.clientId,
    scope: 'openid profile email name groups',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 10,
    logLevel: LogLevel.Error,
  },
};
